import { getData, postData } from '@/utils/fetch';
import type { ServiceInfo, PermissionCodes } from './type';
import { AccountInfo } from '@/types/account-types';
import { MultiCaptchaInfo } from '@jg/captcha-sdk/dist/type';

/**
 * 获取最近开头服务、访问服务
 */
export const getService = (OrgId: string) =>
  getData<ServiceInfo>(`/api/console/organization/info/o-${OrgId}/overview`);

/**
 * 开通服务
 */
export const enableService = (OrgId: string, params: { business: string }) =>
  postData<ServiceInfo>(`/api/console/organization/o-${OrgId}/setting/business/enable`, params);

/**
 * 保存用户信息
 * @param firstName 姓
 * @param lastName 名
 * @param areaCode 区号
 * @param phone 手机号
 */

export const saveUserInfo = (
  firstName: string,
  lastName: string,
  areaCode: string,
  phone: string,
  callbackUrl: string,
) =>
  postData(`/api/console/account/setting/profile/save`, {
    firstName,
    lastName,
    areaCode,
    phone,
    callbackUrl,
    language: navigator.language,
  });

/**
 * 获取当前用户权限
 * @param OrgId 组织ID
 */
export const getUserPermission = (OrgId: string) =>
  getData<PermissionCodes>(`/api/console/permission/info/o-${OrgId}/current`, {
    business: 'Console',
    category: 'default',
  });

/**
 * 获取SDK列表
 */
export const getSdkList = () => getData<any>(`/api/console/sdk/portal/publish-list`);

// 修改名称
export const saveName = (params: { firstName?: string; lastName?: string }) =>
  postData(`/api/console/account/setting/profile/name/save`, params);

// 发送邮件验证码
export function emailSend(email: string, multiCaptchaInfo: MultiCaptchaInfo) {
  return postData(`/api/console/account/verify/code/email/send`, { email, multiCaptchaInfo });
}

//验证邮件验证码
export function emailCheck(email: string, verifyCode: string) {
  return postData(`/api/console/account/verify/code/email/check`, { email, verifyCode });
}

//修改邮件
export function emailUpdate(params: {
  oldEmail: string;
  oldEmailVerifyCode: string;
  email: string;
  emailVerifyCode: string;
}) {
  return postData(`/api/console/account/setting/email/update`, params);
}

// 发送手机验证码
export function phoneSend(
  areaCode: string,
  phone: string,
  userLabel: string,
  multiCaptchaInfo: MultiCaptchaInfo,
) {
  return postData<{ dynamicToken: string }>(`/api/console/account/verify/code/send`, {
    phone,
    areaCode,
    userLabel,
    multiCaptchaInfo,
  });
}

//验证手机验证码
export function phoneCheck(areaCode: string, phone: string, verifyCode: string) {
  return postData(`/api/console/account/verify/code/check`, { phone, areaCode, verifyCode });
}

//修改手机
export function phoneUpdate(params: {
  oldAreaCode: string;
  oldPhone: string;
  oldPhoneVerifyCode: string;
  areaCode: string;
  phone: string;
  phoneVerifyCode: string;
}) {
  return postData(`/api/console/account/setting/phone/update`, params);
}
// 修改回调地址
export function saveCallackUrl(callbackUrl: string) {
  return postData(`/api/console/account/setting/callback-url/save`, { callbackUrl });
}

// 查询当前登录账号的信息
export const getUserInfo = () => {
  return getData<AccountInfo>(`/api/console/account/info/current`);
};

// 人机校验
export const humanCheck = (params: {
  turnstile?: { token: string };
  key: string;
  captcha?: { uuid: string; code: string };
}) => {
  return postData(`/api/console/account/verify/human/check`, params);
};

// 人机校验(图片校验,得到图片)
export const humanCaptcha = (uuid: string, key: string) => {
  return postData(
    `/api/console/account/verify/human/captcha`,
    { uuid, key },
    undefined,
    undefined,
    'blob',
  );
};
